import { useEffect, useRef, useState } from "react";
import { getFrontendVersion } from "../config/apiRoutes";

const FRONTEND_VERSION = process.env.REACT_APP_FRONTEND_VERSION;

export function useFrontendVersionChecker() {
  const [showUpdate, setShowUpdate] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    async function checkVersion() {
      try {
        const res = await fetch(getFrontendVersion);
        if (!res.ok) return;
        const data = await res.json();
        if (data?.frontend_version && data.frontend_version !== FRONTEND_VERSION) {
          setShowUpdate(true);
        } else {
          setShowUpdate(false);
        }
      } catch (e) {
        // ignore
      }
    }
    checkVersion();
    intervalRef.current = setInterval(checkVersion, 5 * 60 * 1000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return showUpdate;
}
